// @flow
import { Card } from '@mui/material';
import React from 'react';
import Chart from 'react-apexcharts';

// simple donut chart
export const DonutChart = (data) => {
    // default options

    const labelsdata = data.data?.labelTypesData?.map((label) => label.labelType) || [];
    const Lablerange = data.data?.labelTypesData?.map((label) => label.count) || [];

    const apexDonutOpts = {
        chart: {
            height: 320,
            type: 'pie',
        },
        labels: labelsdata,
        colors: ['#727cf5', '#6c757d', '#0acf97', '#fa5c7c', '#e3eaef'],
        legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'center',
            verticalAlign: 'middle',
            floating: false,
            fontSize: '14px',
            offsetX: 0,
            offsetY: -10,
        },
        responsive: [
            {
                breakpoint: 600,
                options: {
                    chart: {
                        height: 550,
                    },
                    legend: {
                        show: true,
                    },
                },
            },
        ],
    };

    // chart data
    const apexDonutData = Lablerange;

    return <Chart options={apexDonutOpts} series={apexDonutData} type="donut" height={320} className="apex-charts" />;
};

export const DonutChartPayment = (data) => {
    // default options
    const labelsdata = data.data?.paymentGatewaysData?.map((label) => label.paymentGateway) || [];
    const Lablerange = data.data?.paymentGatewaysData?.map((label) => label.count) || [];
    const apexDonutOpts = {
        chart: {
            height: 320,
            type: 'pie',
        },
        labels: labelsdata,
        colors: ['#6c757d', '#0acf97', '#fa5c7c', '#e3eaef'],
        legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'center',
            verticalAlign: 'middle',
            floating: false,
            fontSize: '14px',
            offsetX: 0,
            offsetY: -10,
        },

        responsive: [
            {
                breakpoint: 600,
                options: {
                    chart: {
                        height: 550,
                    },
                    legend: {
                        show: true,
                    },
                },
            },
        ],
    };

    // chart data
    const apexDonutData = Lablerange;

    return <Chart options={apexDonutOpts} series={apexDonutData} type="donut" height={320} className="apex-charts" />;
};
